import axios from "axios";
import ReactDom from "react-dom";

let Ajax= {}
let load = ReactDom.findDOMNode(document.getElementById("page-load"));

Ajax.get = function(url,data){
	//console.log(url)
	showLoad();
	return new Promise((resolve,resject) => {
		axios.get(url,data).then((res)=>{
			hidnLoad();
			resolve(res);
		});
	})
}
Ajax.post = function(url,data){
	//console.log(url)
	showLoad();
	return new Promise((resolve,resject) => {
		axios.post(url,data).then((res)=>{
			hidnLoad();
			resolve(res);
		});
	})
}

function showLoad(){
	load.style.display = "block";
}
function hidnLoad(){
	load.style.display = "none";
}

export default Ajax;
